import { type LocationListItemsType } from './types';

export const manageOnLocationsChange = (
  selectedLocations: string[],
  onChange: (locations: string[]) => void,
  allDropdownItemsByKey: Record<string, LocationListItemsType | undefined>,
) => {
  const newSelected = selectedLocations.reduce((acc: string[], location: string) => {
    const item = allDropdownItemsByKey[location];

    if (item) {
      if (item.type !== 'group') {
        acc.push(item.value);
      }

      const businessAddressExistAsLocation =
        allDropdownItemsByKey[item.meta?.businessAddressId ?? ''];

      if (
        item.meta?.businessAddressId &&
        item.meta.businessAddressId !== item.value &&
        !businessAddressExistAsLocation
      ) {
        acc.push(item.meta.businessAddressId);
      }
    }

    return acc;
  }, []);

  onChange(newSelected);
};

export const manageSelectedItems = (
  selectedLocations: string[],
  allDropdownItemsByKey: Record<string, LocationListItemsType | undefined>,
) => {
  const newSelected = selectedLocations.filter((location: string) => {
    const item = allDropdownItemsByKey[location];

    return !!item;
  });

  return newSelected;
};

export const getLocationItemsByKey = (
  allDropdownItems: LocationListItemsType[],
): Record<string, LocationListItemsType> => {
  const itemsByKey: Record<string, LocationListItemsType> = {};

  const traverse = (items: LocationListItemsType[]) => {
    items.forEach((item) => {
      if (item.children.length > 0) {
        traverse(item.children);
      }
      itemsByKey[item.value] = item;
    });
  };

  traverse(allDropdownItems);

  return itemsByKey;
};
